import React, { useState, useEffect } from 'react';

const SimpleForm = ({ initialData, fields, onSubmit, onCancel, loading }) => {
    const [formData, setFormData] = useState({});

    useEffect(() => {
        const initial = {};
        fields.forEach(field => {
            initial[field.name] = initialData?.[field.name] || '';
        });
        setFormData(initial);
    }, [initialData, fields]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <form onSubmit={handleSubmit} className="form">
            {fields.map(field => (
                <div key={field.name} className="form-group">
                    <label>
                        {field.label}
                        {field.required && ' *'}
                    </label>
                    {field.type === 'textarea' ? (
                        <textarea
                            name={field.name}
                            value={formData[field.name] || ''}
                            onChange={handleChange}
                            required={field.required}
                            placeholder={field.placeholder}
                            rows={field.rows || 3}
                        />
                    ) : field.type === 'select' ? (
                        <select
                            name={field.name}
                            value={formData[field.name] || ''}
                            onChange={handleChange}
                            required={field.required}
                        >
                            {(field.options || []).map((opt) => (
                                <option key={String(opt.value)} value={opt.value}>
                                    {opt.label}
                                </option>
                            ))}
                        </select>
                    ) : (
                        <input
                            type={field.type || 'text'}
                            name={field.name}
                            value={formData[field.name] || ''}
                            onChange={handleChange}
                            required={field.required}
                            placeholder={field.placeholder}
                        />
                    )}
                </div>
            ))}

            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={onCancel} disabled={loading}>
                    Отмена
                </button>
                <button type="submit" className="btn btn-primary" disabled={loading}>
                    {loading ? 'Сохранение...' : (initialData ? 'Обновить' : 'Создать')}
                </button>
            </div>
        </form>
    );
};

export default SimpleForm;

